import { Link } from 'react-router-dom'

import ZaiTagButton from 'components/ZaiTagButton'

import type { IZaiPrePromptLinkViewProps } from './zai-pre-prompt-link.types'

import './zai-pre-prompt-link.styles.scss'

export const ZaiPrePromptLinkView: React.FC<IZaiPrePromptLinkViewProps> = ({
  children,
  url,
  variant = 'purple',
  onClickLink,
}) => (
  <Link to={url} className="ZaiPrePromptLink" onClick={onClickLink}>
    <ZaiTagButton variant={variant}>{children}</ZaiTagButton>
  </Link>
)
